//
export default {
    //
    product: [
        {
            text: 'código proveedor',
            value: 'provider_product_code',
            input: {
                type: 'text-field',
            },
            width: '10%',
        },
        {
            text: 'código interno',
            value: 'internal_code',
            width: '10%',
        },
        {
            text: 'nombre',
            value: 'name',
        },
        {
            text: 'stock bodega',
            value: 'stock',
            align: 'right',
            width: '10%',
        },
        {
            text: 'stock sucursal',
            value: 'stock_branch',
            align: 'right',
            width: '10%',
        },
        {
            text: 'precio neto',
            value: 'net_price',
            align: 'right',
            format: 'currency',
            input: {
                reverse: true,
                type: 'currency-field',
            },
            width: '13%',
        },
        {
            text: 'cantidad',
            value: 'quantity',
            format: 'number',
            align: 'right',
            input: {
                reverse: true,
                type: 'float-field',
            },
            width: '15%',
        },
    ],

    //
    order: [
        {
            text: '#',
            value: 'id',
        },
        {
            text: 'n° factura',
            value: 'invoice_number',
        },
        {
            text: 'neto',
            value: 'net_subtotal',
            format: 'currency',
        },
        {
            text: 'iva',
            value: 'iva',
            format: 'currency',
        },
        {
            text: 'total',
            value: 'total',
            format: 'currency',
        },
        {
            text: 'estado',
            value: ({ pch_purchase_order_state }) =>
                pch_purchase_order_state.state || '',
            component: {
                type: 'chip',
                props: {
                    disabled: true,
                    label: true,
                    small: true,
                    textColor: 'black',
                },
            },
        },
        {
            text: 'fecha de creación',
            value: 'created_at',
            format: 'datetime',
        },
    ],
}
